import { assertReferralAccess } from './referralAccessPlan.js'

export const DISTRICT_FIXTURE_KINDS = [
  'owned',
  'support504',
  'unassigned',
  'initialOwned',
  'initialEvalOwned',
  'initialUnassigned'
]

// Independent expectations: allSchools opens the school perimeter, not edit ownership.
export function districtExpectation(role, kind, operation) {
  if (role === 'district_admin') return true
  if (role === 'district_coordinator') return false
  if (!['case_manager', 'case_manager_full', 'speech_case_manager'].includes(role))
    throw new Error('Unsupported district smoke role')
  if (operation === 'edit') return ['owned', 'initialOwned', 'initialEvalOwned'].includes(kind)
  if (kind === 'initialUnassigned') return false
  return role === 'case_manager_full' || kind !== 'unassigned'
}

export async function runDistrictAccessChecks(profiles, fixtures, io, step) {
  for (const profile of profiles) {
    const label = profile.label
    await step(`${label}: verify JWT and district scope`, () => io.as(profile))
    for (const fixture of fixtures) {
      for (const operation of ['read', 'edit']) {
        const allowed = districtExpectation(profile.role, fixture.kind, operation)
        await step(
          `${label} / campus ${fixture.campus + 1} / ${fixture.kind}: ${operation} ${allowed ? 'allow' : 'deny'}`,
          () => assertReferralAccess(allowed, () => io[operation](fixture))
        )
      }
    }
    await step(`${label}: cross-school list matches allowed fixtures`, async () => {
      if (profile.role === 'district_coordinator')
        return assertReferralAccess(false, () => io.list(profile))
      const actual = (await io.list(profile)).sort()
      const expected = fixtures
        .filter((f) => districtExpectation(profile.role, f.kind, 'read'))
        .map((f) => f.ref.id)
        .sort()
      if (JSON.stringify(actual) !== JSON.stringify(expected))
        throw new Error(
          'Cross-school student list differs from the expected assignment and referral boundaries'
        )
      return `${actual.length} expected synthetic students across two campuses`
    })
    await step(
      `${label}: school settings ${['district_admin', 'district_coordinator'].includes(profile.role) ? 'allow' : 'deny'}`,
      () =>
        assertReferralAccess(
          ['district_admin', 'district_coordinator'].includes(profile.role),
          () => io.settings(profile)
        )
    )
  }
}
